import React, { useState } from 'react';

import { Control } from '@vlabs/uikit';
import type { BaseButtonProps } from '@vlabs/uikit/components/controls/button/base-button/BaseButton';
import type { WithDataTestid } from '@vlabs/uikit/types';

import { buildTestid } from '@vlabs/monokit/shared/lib/utils';

import st from './SendAlarmButton.module.sass';
import type { SendAlarmProps } from './types';
import { useAlarmHandler } from './useAlarmHandler';
import { useDelay } from './useDelay';

interface SendAlarmButton extends SendAlarmProps, BaseButtonProps, WithDataTestid {}

const displayName = 'SendAlarmButton';
const testid = buildTestid(displayName);

export function SendAlarmButton({
  eventId,
  'data-testid': dataTestId = undefined,
  ...props
}: SendAlarmButton): React.JSX.Element | null {
  const [isPending, setIsPending] = useState(false);

  const alarmHandler = useAlarmHandler({ eventId });
  const { disabled, delayMessage, setDelay } = useDelay({ eventId });

  if (!alarmHandler) return null;

  const isButtonDisabled = disabled || isPending;

  const handleClick = async () => {
    setIsPending(true);

    try {
      await alarmHandler();
      setDelay();
    } finally {
      setIsPending(false);
    }
  };

  return (
    <div className={st.SendAlarmButton}>
      <Control.AlarmButton
        disabled={isButtonDisabled}
        onClick={handleClick}
        size="large"
        {...testid(dataTestId)}
        {...props}
      />
      {delayMessage}
    </div>
  );
}
